import { Box } from '@mui/material';

import { PLAN_COLORS } from '../constants';
import type { GeneratedPlan } from '../types';
import { Pill } from './Pill';
import { BadgeSkeletons } from './PlanSkeleton';

interface PlanBadgesProps {
  plan: GeneratedPlan | null;
}

/** Quick-stat chips shown on the right of the page header subtitle row. */
export const PlanBadges = ({ plan }: PlanBadgesProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
    }}
  >
    {plan ? (
      <>
        <Pill color={PLAN_COLORS.green} bg={PLAN_COLORS.greenBg}>
          {plan.summary.totalLeads.toLocaleString()} leads
        </Pill>
        <Pill color={PLAN_COLORS.both} bg={PLAN_COLORS.bothBg}>
          New leads from day {plan.summary.newStartDay}
        </Pill>
        <Pill color={PLAN_COLORS.orange} bg={PLAN_COLORS.orangeBg}>
          {plan.summary.addrsSteady} address{plan.summary.addrsSteady !== 1 ? 'es' : ''}
        </Pill>
        <Pill color={PLAN_COLORS.past} bg={PLAN_COLORS.pastBg}>
          {(plan.summary.dailyBatch ?? plan.summary.lprb).toLocaleString()} leads/day ramp
        </Pill>
      </>
    ) : (
      <BadgeSkeletons />
    )}
  </Box>
);
